import { UpdatePersonPayload } from "@app/store/api/ApiService";

import DetailsFormValues from "../Details/DetailsFormValues";

const getPersonPayloadFromFormData = (
  formData: DetailsFormValues
): Partial<UpdatePersonPayload> => ({
  accounts: formData.accounts.map(({ id, name }) => ({ id, name })),
  cadenceInterval: formData.cadenceInterval,
  color: formData.color,
  crmActivityTypeId: formData.crmActivityTypeId,
  email: formData.email,
  firstName: formData.firstName,
  lastName: formData.lastName,
  phone: formData.phone,
  user: { id: formData.user },
});

export default getPersonPayloadFromFormData;
